require('ui-ng-core-bootstrap');
require('ui-ng-tooltip');
// import 'utility-ng-enumeration';
require('./lib/popover');

angular.module('ui-ng-popover', ['mgcrea.ngStrap.popover', 'ui-ng-tooltip', 'ui-ng-core-bootstrap']);
// module.exports = 'ui-ng-popover';

require('./custom/popover_data_service');
require('./custom/smart_popover');



// WEBPACK FOOTER //
// ./app/vendor/ui-ng-popover/src/main.js